import { Component, OnInit, Output, Input, EventEmitter, AfterContentChecked, OnChanges } from '@angular/core';

import { PackagingCodeListBe, PackagingCodeBe } from './shared/packaging-code.model';
import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { PackagingCodeService } from './packaging-code.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum } from '../shared/enums.model';
import { PArray } from '../shared/packit-array';
import { isNullOrUndefined } from 'util';
import { StatusEnum } from "../shared/enums.model";
import { UserHandling } from '../shared/user-handling';
import { ChineseChangeValueService } from '../chinese-change-value.service';

@Component({
    moduleId: module.id,
    selector: 'search-packaging-code-dlg',
    templateUrl: 'search-packaging-code.html',
    styleUrls: ['packaging-code.css'],
    providers: [PackagingCodeService,ChineseChangeValueService]
})
export class PackagingCodeSearchDlgComponent implements OnInit, OnChanges {
    // Data set vars
    @Output() codeDlgExecuteCommand: EventEmitter<number> = new EventEmitter<number>();
    @Output() codeExecuteCommand: EventEmitter<number> = new EventEmitter<number>();
    @Input() isAlreadyAdded: PackagingCodeBe[] = [];
    @Input() selectedLevel: number;
    @Input() showSelectRadioButtons: boolean;
    @Input() showEditButtons: boolean;
    @Input() showAsDialog: boolean;

    showRadios: boolean = true;
    showButtons: boolean = false;
    showDialog: boolean = true;
    codeSearchResult: PArray<PackagingCodeListBe> = new PArray(new Array<PackagingCodeListBe>());
    selectedCode: PackagingCodeListBe = null;
    isAlreadyAddedPArr: PArray<PackagingCodeBe> = null;
    

    typeDelayTimer: any = null;
    searchKeyStrokeDelay: number = 350;

    searchCodeText: string = '';
    showCodeSearchSpinner: boolean = false;
    errorObj: ErrorObject = null;

    user: UserHandling = new UserHandling();

    constructor(
        private codeService: PackagingCodeService,
        private errHandler: ErrorHandlerService,
        public ChineseChangeValueService:ChineseChangeValueService
    ) {
        errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err));
    }

    onError(error: ErrorObject) {
        this.errorObj = this.errHandler.getError();
    }

    // ----------------------------------------------------------
    // Life cycle hooks
    // ----------------------------------------------------------
    ngOnInit(): void {
        this.showRadios = this.showSelectRadioButtons;
        this.showButtons = this.showEditButtons;
        this.showDialog = this.showAsDialog;
        document.getElementById("SearchCodeInput").focus();
    }
  
    ngOnChanges(): void {
        this.isAlreadyAddedPArr = new PArray(this.isAlreadyAdded);
    }

    // ----------------------------------------------------------
    // Tab record counts
    // ----------------------------------------------------------
    searchCodes() {
        this.showCodeSearchSpinner = true;
        this.codeSearchResult = null;
        this.errorObj = null;
        clearInterval(this.typeDelayTimer);

        this.codeService.getCodeSearchList(this.searchCodeText, this.selectedLevel)
            .subscribe(returnObject => this.searchCodesResult(returnObject));
    }

    searchCodesResult(returnObject: IReturnObject) {
        this.codeSearchResult = new PArray(new Array<PackagingCodeListBe>());
        this.selectedCode = null;

        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'PackagingCodeSearchComponent.searchCodesResult', returnObject.ErrorType);
        else
            this.codeSearchResult = new PArray(returnObject.DataList);

        this.showCodeSearchSpinner = false;
    }

    //to check whether API is Packaging /Sequencing 
  isPackaging():boolean
  {
    //console.log(window.location.href);
    var pathArray=window.location.href.split('/');
    var lastElement=pathArray[pathArray.length-1];  //to get the last element of url
    //console.log(lastElement);
    if(lastElement=='sequence_instruction')
        {
            return true;
        }

        return false;

  }
    searchResult() {
           
        if (this.codeSearchResult != null && this.searchCodeText.length > 1 )
           {
                if(this.isPackaging()){

                    return this.refineSearchSequenceResult();
                   
                }
                else{
                    return this.refineSearchResult();
                }  
           }
        else
            return [];
    }

    refineSearchResult(): Array<PackagingCodeListBe> {
        if (!this.authorizedForScrappedPkgCode()) {
           
            return this.codeSearchResult.Array().filter(x => x.StatusId != StatusEnum.Scrapped);
        }
        else {
            return this.codeSearchResult.Array()
        }
    }
    refineSearchSequenceResult(): Array<PackagingCodeListBe> {
        if (!this.authorizedForScrappedPkgCode()){

            return this.codeSearchResult.Array().filter(x => x.StatusId != StatusEnum.Scrapped) 
        }
        else{
               /* return this.codeSearchResult.Array().filter(x=>x.PkgCode!=95&&x.PkgCode!=99 &&x.PkgCode!=2370&&x.PkgCode!=211
                     &&x.PkgCodeDesc!="Wooden box"&&x.PkgCodeDesc!="Wooden crate"&&x.PkgCodeDesc!="Container"
                     &&x.PkgCodeDesc!="Plywood box"&&x.PkgCodeDesc!="Wooden frame"&&x.PkgCodeDesc!="Wooden pallet"&&x.PkgCodeDesc!="Engine box"
                     &&x.PkgCodeDesc!="Plastic ESD bag"&&x.PkgCodeDesc!="DG cardboard box"&&x.PkgCodeDesc!="Bubble foil"
                     &&x.PkgCodeDesc!="Neutral Bubble foil"&&x.PkgCodeDesc!="Neutral ESD bubble foil"&&x.PkgCodeDesc!="Neutral crate chosen by the supplier");   
       */
                     return this.codeSearchResult.Array().filter(x=>x.PkgCode!='99'&&x.PkgCode!='95'&&x.PkgCode!='211' && !x.PkgCode.startsWith('568'));
                    }
      }

    authorizedForScrappedPkgCode(): boolean {
        return (this.user.IsPackagingAdmin
            || this.user.IsPackagingEngineer
            || this.user.IsTestPackager
            || this.user.IsPackaginDepartment
            || this.user.IsDeveloper)
    }

    searchCodeTextChanged() {
        var that = this; // needed to preserve scope reference to this within setinterval function

        if (this.searchCodeText.length > 1) {

            // If this.typeDelayTimer is not nulll then the  
            // user typed somthing new within time limit so reset timer
            if (this.typeDelayTimer != null)
                clearInterval(this.typeDelayTimer);

            this.typeDelayTimer = setInterval(function () {
                that.searchCodes();
            }, this.searchKeyStrokeDelay);
        }
        else {
            this.codeSearchResult = new PArray(new Array<PackagingCodeListBe>());
            clearInterval(this.typeDelayTimer);
        }
    }

    okClose() {
        this.codeDlgExecuteCommand.emit(this.selectedCode.PkgCodeId);
    }

    editCode(codeId: number) {
        this.codeExecuteCommand.emit(codeId);
    }

    closeDlg() {
        this.codeDlgExecuteCommand.emit(null);
    }

    setSelectedCode(code: PackagingCodeListBe): void {
        if (this.showButtons) {

            this.editCode(code.PkgCodeId);
        }
        else {
            this.selectedCode = null;
            this.selectedCode = code;
        }
    }

    isNoSelection(): boolean {
        return this.selectedCode == null;
    }

    isChecked(pkgCode: PackagingCodeListBe): boolean {
        if (this.selectedCode == null)
            return;
        document.getElementById("SearchCodeDlgOkButton").focus;
        return this.selectedCode.PkgCodeId == pkgCode.PkgCodeId;
    }

    isAlreadySelected(pkgCodeId: number): boolean {
        let inx = this.isAlreadyAddedPArr.getIndexByProperty("CodeConstraintId", pkgCodeId);
        return inx != null;
    }

    onSingleAddCode(event) {
        if (event.key === "Enter" && this.searchResult().length === 1) {
            this.codeDlgExecuteCommand.emit(this.searchResult()[0].PkgCodeId);
        }
    }

    onSelectAddCode(event, code: PackagingCodeListBe) {
        if (event.key === "Enter") {
            this.codeDlgExecuteCommand.emit(code.PkgCodeId);
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/packaging-code/search-packaging-code.component.ts